import { FunctionComponent } from 'react';

// components
import { PriceAmount } from './PriceAmount';

type Props = {
    price?: number;
    originalPrice?: number;
    percentageOff?: number;
    currency: string;
    quantityDisplay: string | null;
    hasPrivateOffer?: boolean;
};

/**
 * Price Components for an item on sale
 *  (Sale or Sale & Original)
 */
export const SaleItemPrices: FunctionComponent<Props> = ({
    price,
    originalPrice,
    currency,
    percentageOff,
    quantityDisplay,
    hasPrivateOffer,
}) => (
    <>
        {/* SALE PRICE */}
        <PriceAmount
            type="SALE"
            currency={currency}
            amount={price}
            quantityDisplay={quantityDisplay}
        />
        {/* ORIGINAL PRICE */}
        {!!originalPrice && (
            <PriceAmount
                hasSalePrice
                discount={percentageOff}
                currency={currency}
                amount={originalPrice}
                quantityDisplay={quantityDisplay}
                hasPrivateOffer={hasPrivateOffer}
            />
        )}
    </>
);
